import { useState } from 'react';
import ReservationCheckInAction, { ReservationCheckInActionProps } from './ReservationCheckInAction';

export const ReservationCheckInActionWithState = (
    props: Omit<ReservationCheckInActionProps, 'onButtonClick' | 'onClose' | 'active'>
) => {
    const [active, setActive] = useState<boolean>(false);
    const setOpen = () => setActive(true);
    const setClosed = () => setActive(false);

    return <ReservationCheckInAction onButtonClick={setOpen} onClose={setClosed} active={active} {...props} />;
};
